import { haptic } from "@/lib/haptic";

/**
 * Semantic haptic vocabulary for chat. Components call these by interaction
 * name so the intensity mapping lives in one place.
 */
export const chatHaptics = {
  /** Message handed to the send pipeline. */
  send: () => haptic("light"),
  /** Send failed (validation/upload/network). */
  sendFailed: () => haptic("error"),
  /** Long-press context menu opened on a message. */
  messageMenuOpen: () => haptic("medium"),
  /** Reaction added/removed (chip tap, quick bar, double-tap heart). */
  reactionPop: () => haptic("light"),
  /** Scrubbing across the emoji picker grid. */
  emojiScrub: () => haptic("selection"),
  /** Voice recording started. */
  recordStart: () => haptic("medium"),
  /** Voice recording stopped/sent. */
  recordStop: () => haptic("light"),
  /** Hands-free recording lock engaged. */
  recordLock: () => haptic("success"),
  /** Slide-to-cancel threshold crossed while recording. */
  recordCancelThreshold: () => haptic("warning"),
  /** View-once media revealed. */
  viewOnceReveal: () => haptic("medium"),
  /** View-once switched on/off in the composer. */
  viewOnceToggle: () => haptic("selection"),
  /** Poll option toggled. */
  pollVote: () => haptic("selection"),
  /** Content copied to clipboard. */
  copied: () => haptic("success"),
  /** Message forwarded / shared to chats. */
  forwarded: () => haptic("success"),
  /** Attachment tray / picker opened. */
  attachmentTrayOpen: () => haptic("light"),
  /** The Hiive bot answered the viewer's own question (once per answer). */
  botReplied: () => haptic("light"),
  /** Scroll-to-latest FAB pressed. */
  scrollToLatest: () => haptic("light"),
} as const;
